import React, { useEffect } from 'react';
import { Form, Input, Button, Modal, InputNumber, message } from 'antd';
import {
  useUpdateTrailerTypeMutation,
  useCreateTrailerTypeMutation,
} from 'reducers/masterData/trailer/api';

import { useErrorHandler } from 'common_components/ErrorContext';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { goBack } from 'connected-react-router';

const TrailerTypeFormComponent = (props) => {
  const { formData, isCreate, readonly } = props;
  const [form] = Form.useForm();
  const { setErrorData } = useErrorHandler();

  const dispatch = useDispatch();
  const [
    createTrailerType,
    {
      isSuccess: isSuccessCreating,
      isUninitialized: isUninitCreating,
      error: errorCreating,
      isLoading: isCreating,
    },
  ] = useCreateTrailerTypeMutation();

  const [
    updateTrailerType,
    {
      isSuccess: isSuccessUpdating,
      isUninitialized: isUninitUpdating,
      error: errorUpdating,
      isLoading: isUpdating,
    },
  ] = useUpdateTrailerTypeMutation();

  useEffect(() => {
    if (errorCreating) {
      setErrorData(errorCreating);
    }
    if (errorUpdating) {
      setErrorData(errorUpdating);
    }
  }, [errorUpdating, errorCreating, setErrorData]);

  useEffect(() => {
    if (
      (!isUninitUpdating && isSuccessUpdating) ||
      (!isUninitCreating && isSuccessCreating)
    ) {
      message.success('Data was successfully saved');
      if (isSuccessCreating) {
        dispatch(goBack());
      }
    }
  }, [
    isSuccessUpdating,
    isUninitUpdating,
    isSuccessCreating,
    isUninitCreating,
    dispatch,
  ]);

  const onFinish = (values) => {
    Modal.confirm({
      title: 'Confirm',
      icon: <ExclamationCircleOutlined />,
      content: 'Are you sure want to submit?',
      okText: 'Confirm',
      cancelText: 'Cancel',
      onOk: handleConfirmAction,
    });
  };

  const handleConfirmAction = () => {
    let validData = form.getFieldsValue(true);

    let postData = {
      id: formData && formData.id,
      ...validData,
    };

    if (isCreate) {
      createTrailerType(postData);
    } else {
      updateTrailerType(postData);
    }
  };

  return (
    <Form
      form={form}
      name='basic'
      labelCol={{
        span: 4,
      }}
      wrapperCol={{
        span: 10,
      }}
      style={{ padding: '20px' }}
      onFinish={onFinish}
      autoComplete='off'
    >
      <Form.Item
        wrapperCol={{
          offset: 12,
          span: 12,
        }}
      >
        <Button
          type='primary'
          htmlType='submit'
          loading={isCreating || isUpdating}
          disabled={readonly}
        >
          Submit
        </Button>
      </Form.Item>
      <Form.Item
        label='Name'
        name='name'
        initialValue={formData && formData.name}
        rules={[
          {
            required: true,
            message: 'Please input trailer type name',
          },
        ]}
      >
        <Input disabled={readonly} placeholder={'Trailer type'} />
      </Form.Item>
      <Form.Item
        label='Name TH'
        name='name_th'
        initialValue={formData && formData.name_th}
        rules={[
          {
            required: true,
            message: 'Please input name',
          },
        ]}
      >
        <Input disabled={readonly} placeholder={'Name TH'} />
      </Form.Item>
      <Form.Item
        label='Code'
        name='code'
        initialValue={formData && formData.code}
        rules={[
          {
            required: true,
            message: 'Please input code',
          },
        ]}
      >
        <Input disabled={readonly} placeholder={'Code'} />
      </Form.Item>

      <Form.Item
        label='Description'
        name='description'
        initialValue={formData && formData.description}
      >
        <Input disabled={readonly} placeholder={'Trailer type description'} />
      </Form.Item>
      <Form.Item
        label='Maximum Loading'
        name='maximum_loading'
        initialValue={formData && formData.maximum_loading}
        rules={[
          {
            required: true,
            message: 'Please input maximum loading value',
          },
        ]}
      >
        <InputNumber
          min={0}
          disabled={readonly}
          placeholder={'Maximum loading'}
        />
      </Form.Item>
    </Form>
  );
};

export default TrailerTypeFormComponent;
